import React from 'react';
import { PfmlEmployerFormValues } from "../../pfml/PfmlEmployerFormValues";
import DateRange from "../../input/DateRange";
import Checkbox from "../../input/Checkbox";
import TwoColumnDiv from "../../structure/TwoColumnDiv";
import NumericInput from "../../input/NumericInput";
import { useFormikContext } from "formik";
import QuestionPanel from "../../structure/QuestionPanel";

const OtherLeave = () => {
    const { values } = useFormikContext<PfmlEmployerFormValues>();

    return (
        <QuestionPanel headerText="Has your employee taken leave in the past 52 weeks?"
                       detailsText="If your employee is still on leave, please add the start date of leave and keep the end date blank."
                       panelContent={
                           <>
                               <Checkbox id="prior-disability" label="Disability"/>
                               {(values as PfmlEmployerFormValues)?.priorDisability &&
                                   <DateRange idPrefix="prior-disability-dates" index={0}/>}
                               <Checkbox id="prior-paid-family-medical-leave" label="Paid family or medical leave"/>
                               {(values as PfmlEmployerFormValues)?.priorPaidFamilyMedicalLeave &&
                                   <div>
                                       <DateRange idPrefix="prior-paid-family-medical-leave-dates" index={0}/>
                                       <TwoColumnDiv leftContent={
                                           <NumericInput id="prior-paid-family-medical-leave-hours" label="Total hours of paid leave"
                                                         required={true}/>}>
                                       </TwoColumnDiv>
                                   </div>}
                           </>
                       }/>
    )
};
export default OtherLeave;